import * as React from 'react';
import classNames from 'classnames';

import * as style from './HeaderRow.css';

export interface IHeaderRowProps {
  position: number;
  sticky?: boolean;
}

const HeaderRow = React.forwardRef<HTMLDivElement, React.PropsWithChildren<IHeaderRowProps>>((props, ref) => {
  const { children, sticky } = props;

  return (
    <div ref={ref} className={classNames(style['row'], sticky && style['row--sticky'])}>
      {children}
    </div>
  );
});

HeaderRow.displayName = 'HeaderRow';

export { HeaderRow };
